/* global game, CocoonJS */

var loadState = {

	init: function() {

		this.input.maxPointers = 1;

		this.scale.pageAlignHorizontally = true;

	},

	preload: function() {

		// Add a progress bar
		var progressBar = game.add.sprite( game.world.centerX, game.world.centerY, 'progressBar' );
		progressBar.anchor.setTo( 0.5, 0.5 );
		game.load.setPreloadSprite( progressBar );

		this.load.path = '/assets/games/pixel-peak/';


		// Level

		game.load.tilemap( 'map1', 'levels/map.json', null, Phaser.Tilemap.TILED_JSON );


		// Images

		game.load.image( 'ski-terrain', 'images/ski-terrain.png' );
		game.load.image( 'intro', 'images/splash-screen.png' );
		// game.load.image( 'game-over', 'images/game-over.png' );
		game.load.image( 'font', 'images/font.png' );
		game.load.image( 'hud', 'images/hud.png' );


		// Sprites

		game.load.spritesheet( 'confetti', 'images/confetti.png', 2, 2 );
		game.load.spritesheet( 'game-over', 'images/game-over.png', 64, 30 );
		game.load.spritesheet( 'game-start', 'images/start-game.png', 64, 21 );
		game.load.spritesheet( 'ski-trail', 'images/ski-trail.png', 4, 2 );
		game.load.spritesheet( 'player', 'images/main-character.png', 12, 15 );
		game.load.spritesheet( 'tilemap', 'images/ski-terrain.png', 8, 8 );


		// Audio

		this.loadAudio( 'crash' );
		this.loadAudio( 'weeeeee' );
		this.loadAudio( 'countdown' );
		this.loadAudio( 'jump-land' );
		this.loadAudio( 'lose' );
		this.loadAudio( 'ski-turn' );
		this.loadAudio( 'splash' );
		this.loadAudio( 'win' );
		this.loadAudio( 'wind' );
		this.loadAudio( 'theme' );
		this.loadAudio( 'menu' );

		// Physics

		Phaser.Physics.Arcade.sortDirection = Phaser.Physics.Arcade.TOP_BOTTOM;

	},

	create: function() {

		game.state.start( 'menu' );

	},


	loadAudio: function( file ) {

		var mp3 = 'audio/' + file + '.mp3';
		var ogg = 'audio/' + file + '.ogg';

		game.load.audio( file, [ mp3, ogg ] );

	}

};
